export const SET_TRADE_INFO = "SET_TRADE_INFO";
export const SET_TRADE_FORM = "SET_TRADE_FORM";
export const SET_TRADE_FORM_DETAIL = "SET_TRADE_FORM_DETAIL";
export const SET_SHOW_POLICY = "SET_SHOW_POLICY";
export const SET_SHOW_TOGGLE = "SET_SHOW_TOGGLE";
